import React from 'react';
import { useTranslation } from 'react-i18next';
import translations from 'services/translations/translations';
import { Row, Col, Label } from 'reactstrap';
import IPosition from 'interfaces/projects/IPosition';
import TextInputWithSubmit from './TextInputWithSubmit';
import TrashIcon from '../icons/TrashIcon';
import EditIcon from '../icons/EditIcon';

import 'style/layout/form/CreatableListForPositions.css';

const CreatableList = ({
  elements,
  title,
  addElement,
  name,
  removeElement,
  updateElement,
}: {
  elements: IPosition[];
  title: string;
  addElement: (form: any, e: any) => void;
  name: string;
  removeElement: (e: string) => void;
  updateElement: (e: string) => void;
}): JSX.Element | null => {
  const { t } = useTranslation([translations.common]);
  const showElements = () => {
    return elements.map((element) => {
      return (
        <Row key={element.name}>
          <Col xs={4} className="grey-text">
            {element.name}
          </Col>
          <Col xs={1}>
            <EditIcon
              onClick={() => {
                updateElement(element.name);
              }}
            />
          </Col>
          <Col xs={1}>
            <TrashIcon
              onClick={() => {
                removeElement(element.name);
              }}
            />
          </Col>
        </Row>
      );
    });
  };

  return (
    <>
      <Row className="button-margin-top">
        <Col>
          <Label className="label">{title}</Label>
        </Col>
      </Row>
      {showElements()}
      <TextInputWithSubmit name={name} required={false} submit={addElement} />
    </>
  );
};

export default CreatableList;
